// calculateDistance liefert null, wenn kein Standort bekannt ist, und 999 bei ungültigen
// Koordinaten. Number(null) wäre 0 und würde fälschlich „0 m“ anzeigen.
export const toDistance = (value) => {
  if (value === null || value === undefined || value === '') return Number.NaN;
  const distance = Number(value);
  return Number.isFinite(distance) && distance < 999 ? distance : Number.NaN;
};
